export default "__VITE_ASSET__jKUb$sc___"